import { BookOpen, MapPin, Flame, CalendarDays, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { useGo } from "@/lib/nav";

const PATHWAYS = [
  {
    id: "discover",
    to: "#discover",
    icon: BookOpen,
    title: "Discover Mary",
    topics: ["Who is Mary?", "Mary in Scripture", "The four dogmas", "Mary and the saints"],
  },
  {
    id: "apparitions",
    to: "/apparitions",
    icon: MapPin,
    title: "Apparitions & Shrines",
    topics: ["Apparitions & living devotions", "Marian shrines of the world", "How the Church discerns"],
  },
  {
    id: "pray",
    to: "/prayer-and-devotion",
    icon: Flame,
    title: "Prayer & Devotions",
    topics: ["The Holy Rosary", "Marian prayers", "Novenas", "Consecration to Jesus through Mary"],
  },
  {
    id: "today",
    to: "/calendar",
    icon: CalendarDays,
    title: "Feasts & Calendar",
    topics: ["The Marian calendar, East & West", "May, month of Mary", "October, month of the Rosary"],
  },
];

export default function Pathways() {
  const go = useGo();
  return (
    <section data-testid="pathway-cards" className="bg-paleblue/50 py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <SectionHeading eyebrow="Four doors into the treasury" title="Begin where you are" />

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {PATHWAYS.map((path, i) => (
            <Reveal key={path.id} delay={i * 0.08} className="h-full">
              <button
                type="button"
                data-testid={`pathway-${path.id}`}
                onClick={() => go(path.to)}
                className="card-lift group flex h-full w-full flex-col rounded-2xl border border-marian/15 bg-white/90 p-7 text-left backdrop-blur"
              >
                <span className="flex items-center justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-paleblue text-marian transition-colors duration-300 group-hover:bg-gold group-hover:text-ivory">
                    <path.icon className="h-5 w-5" strokeWidth={1.7} aria-hidden="true" />
                  </span>
                  <ArrowUpRight
                    className="h-5 w-5 text-slateblue/50 transition-all duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-gold"
                    aria-hidden="true"
                  />
                </span>
                <span className="mt-6 font-serif text-xl font-semibold text-midnight sm:text-2xl">
                  {path.title}
                </span>
                <ul className="mt-4 space-y-2">
                  {path.topics.map((topic) => (
                    <li key={topic} className="flex items-baseline gap-2 text-sm text-charcoal/80">
                      <span className="text-gold" aria-hidden="true">
                        ·
                      </span>
                      {topic}
                    </li>
                  ))}
                </ul>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
